import * as React from "react";
import { connect } from "react-redux";
import { Tab, Container } from "semantic-ui-react";

import { ohCaseSelector, routeIdSelector as caseIdSelector } from "../../ohCase/selectors";
import { routeIdSelector as customerIdSelector } from "../../customer/selectors";
import { ApplicationState } from "../../../applicationState";

import { CasePurchaseOrderNumber } from "./CasePurchaseOrderNumber";

interface StateProps {
    caseId: string;
    customerId: string;
    purchaseOrderNumber: string;
}

const FinanceInformationTabUnconnected: React.FunctionComponent<StateProps> = ({ caseId, customerId, purchaseOrderNumber }) => {
    return (
        <Container>
            <CasePurchaseOrderNumber
                caseId={caseId}
                customerId={customerId}
                purchaseOrderNumber={purchaseOrderNumber}
            />
        </Container>
    );
};

export const FinanceInformationTab = () => ({
    path: "/financeinformation",
    menuItem: "Finance Information",
    render: () => <Tab.Pane><FinanceInformationTabContent /></Tab.Pane>
});

const mapStateToProps = (state: ApplicationState): StateProps => {
    return {
        caseId: caseIdSelector(state),
        customerId: customerIdSelector(state),
        purchaseOrderNumber: ohCaseSelector(state).purchaseOrderNumber
    };
};

export const FinanceInformationTabContent = connect(mapStateToProps)(FinanceInformationTabUnconnected);
